export function mapGetBearing() { return this._cameraBearing ?? 0; }
